import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { exportData } from 'features/export-data/actions';
import { formatPlural } from 'utils';
import { useFetchOld } from 'hooks';
import Links from 'utils/links';
import useRequiredBenefitCallback from 'features/premium/hooks/useRequiredBenefitCallback';
import Modal from 'utils/packages/Modal';
import { navigationRef } from 'utils/navigationv6';
import { isWeb } from '../../../constants';
const ExportResultContent = ({ accountIds, transactionIds, onAdjustFilters, }) => {
    const [, , isFetching, fetch] = useFetchOld();
    const onExport = useRequiredBenefitCallback(useCallback(async () => {
        const res = await fetch(exportData({ accountIds, transactionIds }));
        if (!res?.link)
            return;
        Links.openLink(res.link);
        ExportResultModal.hide(() => {
            if (isWeb) {
                navigationRef.navigateDeprecated('Success', {
                    title: 'Your data has been successfully downloaded to your device',
                    subTitle: '',
                    onContinue: () => {
                        navigationRef.goBack();
                        return true;
                    },
                    buttonText: 'Close',
                });
            }
        });
    }, [accountIds, transactionIds]), 'export');
    return (<View style={styles.contentContainer}>
      <Spacer.H16 />
      <Text TextThin-14 Secondary centered={!isWeb}>
        {`You are about to export ${transactionIds.length} ${formatPlural('transaction', 'transactions', transactionIds.length)} based on your current search. If you need a different selection, please adjust your filters.`}
      </Text>
      <Spacer h={isWeb ? 24 : 16}/>
      <Button brandReversed title="Adjust filters" onPress={onAdjustFilters} disabled={isFetching}/>
      <Spacer h={8}/>
      <Button brand title={`Export ${transactionIds.length} ${formatPlural('transaction', 'transactions', transactionIds.length)}`} onPress={onExport} isFetching={isFetching}/>
    </View>);
};
export const ExportResultModal = {
    show: (props) => {
        Modal.show(<ExportResultContent {...props}/>, {
            containerStyle: styles.modal,
            title: 'Export search result',
        });
    },
    hide: Modal.hide,
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    contentContainer: {
        paddingHorizontal: rem(16),
    },
});
